<template>
  <div>
    <surveys-table
      surveyName="HIS4"
      surveyCode="HIS4"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_HIS4,
        viewDetail: permissions.SEE_DETAIL_SURVEY_HIS4,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
